import { v2Api } from './v2Client';

export async function fetchDbTools() {
  const { data } = await v2Api.get('/DbTools/tools');
  const list = data?.tools ?? data?.Tools ?? [];
  return Array.isArray(list) ? list : [];
}

export async function executeDbTool({ key, params, dry_run, confirm }) {
  const { data } = await v2Api.post('/DbTools/execute', {
    key,
    params: params || {},
    dry_run: !!dry_run,
    confirm: !!confirm,
  });
  return data;
}
